import { faker } from '@faker-js/faker';

const UUID_ARRAY = faker.helpers.multiple(() => faker.string.uuid(), { count: 200 });

const TEMPLATE_IDS = UUID_ARRAY.slice(0, 100);
const PARAMETER_SET_IDS = UUID_ARRAY.slice(101, 189);
export const NUMBER_TEMPLATES_PARAMETER_SETS = 10;

const FORM_GENERATOR_FIELDS_IDS = UUID_ARRAY.slice(11, 191);
export const NUMBER_FORM_GENERATOR_FIELDS = 5;
const FORM_GENERATOR_CONTAINERS_FIELDS_IDS = UUID_ARRAY.slice(20, 45);
export const NUMBER_FORM_GENERATOR_CONTAINERS_FIELDS = 2;

export function getTemplateIdByIndex(index: number): string {
  const position = index % TEMPLATE_IDS.length;
  return TEMPLATE_IDS[position];
}
export function getParameterSetIdsByIndex(index: number): string {
  const position = index % PARAMETER_SET_IDS.length;
  return PARAMETER_SET_IDS[position];
}
export function getFormGeneratorIdByIndex(index: number): string {
  const position = index % FORM_GENERATOR_FIELDS_IDS.length;
  return FORM_GENERATOR_FIELDS_IDS[position];
}
export function getFormGeneratorContainersIdByIndex(index: number): string {
  const position = index % FORM_GENERATOR_CONTAINERS_FIELDS_IDS.length;
  return FORM_GENERATOR_CONTAINERS_FIELDS_IDS[position];
}

export const DEVICE_DETAILS_PARAMETER_SETS = [
  { parameterSetId: '282ac790-529f-47c4-99b2-4265a496ef40', templateId: '11111111-1b4d-4336-99b8-548e08b05777' },
  { parameterSetId: '9d443f61-7853-47f1-99b3-21305b474ff7', templateId: '22222222-1b4d-4336-99b8-548e08b05777' },
] as const;
